import type { KnockoutTreeStage } from "@motain/xpa-proto-files-web/lib/types/kotree";
import type { KoTreeStageProps } from "@/xpa-components/ko-tree/ko-tree-stage/KoTreeStage";
export const createKoTreeArrayShape = (
  stages: Array<KnockoutTreeStage>,
): Array<KoTreeStageProps> => {
  const koTreeArray: Array<KoTreeStageProps> = [];

  // Build the first half of the knockout tree array
  [...stages].map((stage, index) => {
    if (index === stages.length - 1) {
      // skip the last stage (in this case is the finals)
      return;
    }

    const halfNodes = Math.ceil(stage.nodes.length / 2);

    koTreeArray.push({
      ...stage,
      isReverse: false,
      isSemiFinal: index === stages.length - 2, // this represents the semi-final
      isFinal: false,
      nodes: stage.nodes.slice(0, halfNodes),
    });
  });

  //Build the second half of the knockout tree array
  [...stages].reverse().map((stage, index) => {
    const halfNodes = Math.floor(stage.nodes.length / 2);

    koTreeArray.push({
      ...stage,
      isReverse: true,
      isFinal: index === 0, // 0 is final 1 is semi-final
      isSemiFinal: index === 1,
      nodes: stage.nodes.slice(halfNodes),
    });
  });

  return koTreeArray;
};
